/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { CancelAndRefundRequest } from '../../models/cancel-and-refund-request';
import { ClientId } from '../../models/client-id';
import { FinnairOrderCancelRefund } from '../../models/finnair-order-cancel-refund';

export interface ConfirmCancelAndRefund$Params {
  orderId: string;
  locale?: string;
  hash: string;

/**
 * Session ID in UUID format used to aggregate all the calls for a single customer
 */
  'X-Session-Id'?: string;

/**
 * Client ID representing the caller system
 */
  'X-Client-Id'?: ClientId;

/**
 * W3C Trace Context traceparent header used for distributed tracing
 */
  traceparent?: string;

/**
 * W3C Trace Context tracestate header used for distributed tracing
 */
  tracestate?: string;

/**
 * W3C Baggage header used to propagate contextual key-value pairs
 */
  baggage?: string;
      body: CancelAndRefundRequest
}

export function confirmCancelAndRefund(http: HttpClient, rootUrl: string, params: ConfirmCancelAndRefund$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairOrderCancelRefund>> {
  const rb = new DapiRequestBuilder(rootUrl, confirmCancelAndRefund.PATH, 'post');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('locale', params.locale, {});
    rb.query('hash', params.hash, {});
    rb.header('X-Session-Id', params['X-Session-Id'], {});
    rb.header('X-Client-Id', params['X-Client-Id'], {});
    rb.header('traceparent', params.traceparent, {});
    rb.header('tracestate', params.tracestate, {});
    rb.header('baggage', params.baggage, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairOrderCancelRefund>;
    }),
    catchErrorAsJson()
  );
}

confirmCancelAndRefund.PATH = '/api/v2/order/{orderId}/refund/confirm';
